import { ErrorBoundary } from '@sentry/react';
import React from 'react';
import { ManualDataRefetchCountHandle } from '../../../types';
import {
  DataVizContainerChartDataFetchError,
  ErrorData,
} from './DataVizContainerChartDataFetchError';

interface ChartErrorBoundaryProps {
  children: React.ReactNode;
  manualDataRefetchCountHandle: ManualDataRefetchCountHandle;
}

export const ChartErrorBoundary = (props: ChartErrorBoundaryProps) => {
  const { manualDataRefetchCountHandle, children } = props;
  return (
    <ErrorBoundary
      fallback={(errorData) => (
        <DataVizContainerChartDataFetchError
          manualDataRefetchCountHandle={manualDataRefetchCountHandle}
          errorData={errorData as ErrorData}
        />
      )}
    >
      {children}
    </ErrorBoundary>
  );
};
